module.exports = __webpack_public_path__ + "img/kent_moyen.ad062839.jpg";